<label class="filter-label" for="filter-date-range-select">Date range</label>

<div class="date-range-field">
  <span class="date-range-icon" aria-hidden="true">
    <fa-icon [icon]="calendarIcon" />
  </span>
  <select
    id="filter-date-range-select"
    class="date-range-select"
    data-testid="filter-date-range"
    (change)="onChoiceChange($event)"
  >
    <!--
      [selected] rather than [value] on the <select>: the host element's own
      property bindings run before its @for children exist, so a [value]
      binding would land on an option-less select and silently fall back to the
      first option. Binding the option's `selected` property is correct both on
      first render and on every later change.
    -->
    @for (preset of presets; track preset) {
      <option [value]="preset" [selected]="selectedChoice() === preset">
        {{ presetLabels[preset] }}
      </option>
    }
    <option [value]="customChoice" [selected]="selectedChoice() === customChoice">Custom…</option>
  </select>
</div>

@if (customOpen()) {
  <div class="date-range-custom">
    <label class="filter-label" for="filter-date-range-start-input">Start</label>
    <input
      id="filter-date-range-start-input"
      type="date"
      class="date-range-input"
      data-testid="filter-date-range-start"
      [value]="start()"
      [attr.aria-invalid]="errorMessage() !== null ? 'true' : null"
      [attr.aria-describedby]="errorMessage() !== null ? 'filter-date-range-error' : null"
      (input)="onStartInput($event)"
    />

    <label class="filter-label" for="filter-date-range-end-input">End</label>
    <input
      id="filter-date-range-end-input"
      type="date"
      class="date-range-input"
      data-testid="filter-date-range-end"
      [value]="end()"
      [attr.aria-invalid]="errorMessage() !== null ? 'true' : null"
      [attr.aria-describedby]="errorMessage() !== null ? 'filter-date-range-error' : null"
      (input)="onEndInput($event)"
    />

    <button
      type="button"
      class="btn btn-default btn-sm"
      data-testid="filter-date-range-apply"
      (click)="applyCustom()"
    >
      Apply
    </button>
  </div>
}

@if (errorMessage(); as message) {
  <p
    id="filter-date-range-error"
    class="filter-error"
    data-testid="filter-date-range-error"
    role="alert"
  >{{ message }}</p>
} @else {
  <!-- Reserved so applying an invalid range does not shift the bar (SC-005). -->
  <p class="filter-error" aria-hidden="true"></p>
}
